








import {Component} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {GetDisinfectStatistics} from "@/api/report"

@Component
export default class disinfection extends AbpBase {
	date: any = []
	data: any = []
	columns = [
		{
			title: "消毒开始时间",
			key: 'disinfectSt'
		},
		{
			title: "消毒结束时间",
			key: 'disinfectEnd'
		},
		{
			title: "消毒方式",
			key: 'disinfectType'
		},
		{
			title: "机内消毒剂",
			key: 'jnxdj'
		},
		{
			title: "机外消毒开始时间",
			key: 'outDisinfectSt'
		},
		{
			title: "机外消毒剂",
			key: 'jwxdj'
		},
		{
			title: "床号",
			key: 'bedCode'
		},
		{
			title: "机器序列号",
			key: 'machineXlh'
		},
		{
			title: "操作人",
			key: 'createUser'
		},
	]
	options:any = {}
	created() {
		this.date = this.getMonthStartAndEnd()
		const vm = this
		this.options = {
			shortcuts: [
				{
					text: '这个月',
					value() {
						return vm.getMonthStartAndEnd();
					}
				},
				{
					text: '上个月',
					value() {
						const date = new Date();
						date.setTime(date.getTime() - 3600 * 1000 * 24 * 29);
						return vm.getMonthStartAndEnd(date);
					}
				},
				{
					text: '上上月',
					value() {
						const date = new Date();
						date.setTime(date.getTime() - 3600 * 1000 * 24 * 59);
						return vm.getMonthStartAndEnd(date);
					}
				}
			]
		}
		this.getData()
	}

	dateChange(e:any){
		this.date = e
		this.getData()
	}

	private async getData() {
		let res = await GetDisinfectStatistics({
			StartDate: this.date[0],
			EndDate: this.date[1]
		})
		this.data = res.objects
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/disinfection/index.vue